import FieldIcon_Popover from "./components/popover/popover";
import FieldPopover from "../../../fields3/generic/popover/popover";
import FieldConfig from "../../proto/field-config";
import FieldIcon_FormValueNotEmpty from "./components/form/value-not-empty";
import FieldIcon_FormElement from "./render/form-element";
import FieldIcon_Picker from "./render/picker";
import FieldIcon_View from "./render/view";
import FieldIcon_ValueEmpty from "./components/inline-edit/value-empty";
import FieldIcon_ValueNotEmpty from "./components/inline-edit/value-not-empty";
import FieldIcon_Editable from "./render/editable";

export default class FieldIcon extends FieldPopover {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                      = "Icon";

        this.components.PopoverMenu         = FieldIcon_Popover
        this.components.FormValueNotEmpty   = FieldIcon_FormValueNotEmpty
        this.components.InlineValueEmpty    = FieldIcon_ValueEmpty
        this.components.InlineValueNotEmpty = FieldIcon_ValueNotEmpty

        this.renderComponents.view          = FieldIcon_View
        this.renderComponents.editable      = FieldIcon_Editable
        this.renderComponents.picker        = FieldIcon_Picker
        this.renderComponents.formElement   = FieldIcon_FormElement
    }

    // return icon class
    getDisplayValue(value: any): any {
        return super.getDisplayValue(value);
    }

}
